import { Box, Button } from '@arpeggi/ui'
import { ComponentProps, FC } from 'react'
import { EmptyStateIcon, EmptyStateText, JumpWrapper } from './primitives'

const StyledRoot: FC<ComponentProps<typeof Box>> = (props) => (
  <Box css={{ margin: '50px 0px' }} column alignCenter justifyCenter {...props}>
    {props.children}
  </Box>
)

const StyledIcon: FC<ComponentProps<typeof JumpWrapper>> = (props) => (
  <JumpWrapper {...props}>
    <EmptyStateIcon />
  </JumpWrapper>
)

const StyledText = EmptyStateText

const StyledButtonRow: FC<ComponentProps<typeof Box>> = (props) => (
  <Box row alignCenter justifyCenter {...props}>
    {props.children}
  </Box>
)

const StyledSecondaryButton: FC<ComponentProps<typeof Button>> = (props) => (
  <Button css={{ marginRight: '5px' }} variant="secondary" size="sm" {...props}>
    {props.children}
  </Button>
)

const StyledPrimaryButton: FC<ComponentProps<typeof Button>> = (props) => (
  <Button variant="success" size="sm" {...props}>
    {props.children}
  </Button>
)

export const EmptyState = {
  Root: StyledRoot,
  Icon: StyledIcon,
  Text: StyledText,
  ButtonRow: StyledButtonRow,
  SecondaryButton: StyledSecondaryButton,
  PrimaryButton: StyledPrimaryButton
}
